import Document from '../components/Document';

export default function AboutPage() {
    const aboutUrl = 'https://drive.google.com/file/d/1m4B_pYAD178W9jcd3OaFOsyjwPU8hVgi/preview';

    return (
        <Document url={aboutUrl} title='About' />
    );
}
